
import WishList from '../feature/SkillBox/WishList'

function WishListPage() {
    return (
        <WishList />
    )
}

export default WishListPage;